import { computed } from '@ember/object';
import { equal } from '@ember/object/computed';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

import window from 'ember-window-mock';
import UAParser from 'ua-parser-js';
import { v4 } from 'uuid';

import ENV from 'register-partners-js/config/environment';
import { readCookie, writeCookie } from 'register-partners-js/utils/cookie-manager';
import domain from 'register-partners-js/utils/shared-cookie-domain';

const COOKIE_MAX_AGE_SEC = 31622400; // number of seconds in 12 months

export default class DeviceManager extends Service {
  @tracked id;
  @tracked currentDevice;

  @equal('currentDevice', 'mobile') isMobile;

  constructor() {
    super(...arguments);

    let id = readCookie('deviceId');
    let parser = new UAParser();
    let { type, vendor } = parser.getDevice();

    if (!id) {
      id = v4();
      let options = {
        secure: ENV.environment === 'production',
        domain,
        maxAge: COOKIE_MAX_AGE_SEC,
      };
      writeCookie('deviceId', id, options);
    }

    this.browser = parser.getBrowser();
    this.os = parser.getOS();

    this.id = id;
    this.currentDevice = type;
    this.currentVendor = vendor;
  }

  @computed('id')
  get header() {
    return {
      name: 'X-Qonto-Device',
      value: this.id,
    };
  }

  get isMobileDevice() {
    return this.isMobile || this.isWebview;
  }

  get isMobileBrowser() {
    return this.isMobile && !this.isWebview;
  }

  get isWebview() {
    let androidBridge = window.nativeBridge;
    let iosBridge = window.webkit?.messageHandlers?.nativeBridge;

    return Boolean(androidBridge || iosBridge);
  }
}
